"use strict";
/**
 * @copyright 2020 Microsoft Corporation
 */
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var ax;
    (function (ax) {
        // tslint:disable-next-line:class-name
        var formPersonalizationToolbar = /** @class */ (function () {
            function formPersonalizationToolbar() {
                var _this = this;
                this.UserCloseToolbar = function () {
                    // Order of calling closeToolbarCleanup is important as closeToolbarCleanup calls SavePendingPersonalization
                    // And that has to go first for task recorder steps to be in order
                    _this.closeToolbarCleanup();
                    _this.SendToolbarAction($dyn.ui.personalizationToolbarEvents.ActionUserClose);
                };
                this.ChangeMode = function (mode, forceChange) {
                    if (forceChange === void 0) { forceChange = false; }
                    _this.SavePendingPersonalization();
                    _this.SendToolbarAction(mode);
                    _this.Mode(mode, forceChange);
                };
                // Event Handlers
                this.OnFocus = function (event) {
                    var target = event.target || event.srcElement;
                    var executeNextSteps = !_this._showExpandoQtip(event, target);
                    if (executeNextSteps) {
                        _this.updateAccessibilityDescriptionForTarget(target);
                    }
                };
                /**
                 * Called on dragging of a object in move mode
                 * @param event originating the drag
                 */
                this._handleDrag = function (event) {
                    // event.gesture removed
                    if (event.preventDefault) {
                        event.preventDefault();
                    }
                    var control = _this.selectedForMove;
                    if (control) {
                        var element = _this.getElementOrHeader(control.Name, control.element);
                        if (!_this.isDragging) {
                            $(element).addClass($dyn.ui.personalizationClasses.draggable);
                            $(element).addClass($dyn.ui.personalizationClasses.dragging);
                            $(element).addClass($dyn.ui.personalizationClasses.dragClone);
                            _this.isDragging = true;
                            if (!_this.controlLayoutHorizontal(control)) {
                                var coordinates = element.getBoundingClientRect();
                                _this.positionX = coordinates && coordinates.left ? coordinates.left : 0;
                                _this.positionY = coordinates && coordinates.left ? coordinates.top : 0;
                                _this.origZIndex = element.style.zIndex;
                            }
                            else {
                                _this.positionX = element.offsetLeft;
                                _this.positionY = element.offsetTop;
                            }
                            _this.origStyleX = element.style.left;
                            _this.origStyleY = element.style.top;
                            _this.origPosition = element.style.position;
                        }
                        if (!event.isFinal) {
                            var posX = event.deltaX + _this.positionX;
                            var posY = event.deltaY + _this.positionY;
                            element.style.left = posX + "px";
                            element.style.top = posY + "px";
                            // In edge horizontol layout elements was having problem with position: fixed.
                            // We do not need fixed position in grid as we have listbody as reference.
                            // For controls outside grid position fixed works as we need reference from window there.
                            if (!_this.controlLayoutHorizontal(control)) {
                                element.style.zIndex = _this._moveTargetZIndex; // To make sure it is always on top of all element.
                                element.style.position = "fixed";
                            }
                            else {
                                element.style.position = "absolute";
                            }
                        }
                    }
                    if (event.isFinal) {
                        if (control) {
                            var element = _this.getElementOrHeader(control.Name, control.element);
                            $(element).removeClass($dyn.ui.personalizationClasses.dragging);
                            $(element).removeClass($dyn.ui.personalizationClasses.draggable);
                            $(element).removeClass($dyn.ui.personalizationClasses.dragClone);
                            element.style.left = _this.origStyleX;
                            element.style.top = _this.origStyleY;
                            if (!_this.controlLayoutHorizontal(control)) {
                                element.style.zIndex = _this.origZIndex;
                            }
                            element.style.position = _this.origPosition;
                        }
                        _this.isDragging = false;
                        if (_this.draggableObject) {
                            _this.draggableObject.off("pan", _this._handleDrag);
                        }
                        _this.moveStop();
                    }
                };
                this.Clear = function () {
                    var form = _this.currentVisibleForms[0]; // Get only the root
                    $dyn.callFunction(form.ExecutePersonalizationCommand, form, ["ClearPersonalizations"]);
                };
                this.Import = function () {
                    var form = _this.currentVisibleForms[0]; // Get only the root
                    // Order of calling SystemCloseToolbar is important as SystemCloseToolbar calls SavePendingPersonalization
                    // And that has to go first for task recorder steps to be in order
                    _this.SystemCloseToolbar();
                    $dyn.callFunction(form.ExecutePersonalizationCommand, form, ["ImportPersonalizations"]);
                };
                this.Export = function () {
                    var form = _this.currentVisibleForms[0]; // Get only the root
                    $dyn.callFunction(form.ExecutePersonalizationCommand, form, ["ExportPersonalizations"]);
                };
                this.AddAPage = function () {
                    var form = _this.currentVisibleForms[0]; // Get only the root
                    $dyn.callFunction(form.ExecutePersonalizationCommand, form, ["AddAPage"]);
                };
                this.updateCurrentHelpText = function (event) {
                    if (event.type === "mouseleave") {
                        // leaving so set the text back to selected item
                        _this.CurrentHelpText(_this.CurrentSelectedHelpText());
                    }
                    else {
                        var control = $dyn.context(event.target);
                        if (control && control.HelpText) {
                            if (_this.CurrentHelpText() !== $dyn.value(control.HelpText)) {
                                if (_this.CurrentSelectedHelpText() === "") {
                                    _this.CurrentSelectedHelpText(_this.CurrentHelpText());
                                }
                                _this.CurrentHelpText($dyn.value(control.HelpText));
                            }
                        }
                    }
                };
                // Event Handlers
                this.OnClick = function (event) {
                    var target = event.target || event.srcElement;
                    // Ignore clicks on react grid scrollbars and reorder handles
                    if ($dyn.util.isFlightEnabled($dyn.reactGrid.featureName)) {
                        if (_this.isReactGridScrollbar(target) || _this.isReactGridReorderHandle(target)) {
                            return;
                        }
                    }
                    if (_this.targetIsInteractable(target) || _this.targetIsClickable(target)) {
                        // Do not stop events which are not directed at the form being personalized.
                        if (_this.targetIsClickable(target) && _this.currentTargetControl) {
                            _this._focusExpandoTargetElement(_this.currentTargetControl);
                        }
                        return;
                    }
                    // Hide the show more menu
                    _this.ShowMoreMenu(false);
                    event.stopPropagation();
                    $dyn.log.stopPropagation && $dyn.log.stopPropagation("Stop Click event during Personalization");
                    event.preventDefault();
                    if (!_this.potentialTarget) {
                        // A potential target must exist in order to execute a click.
                        // potentialTarget is set via either mouse over or keyboard navigation
                        return;
                    }
                    _this.EventHandler.onClick(_this, _this.potentialTarget);
                    if (_this._canUpdateFormPersonalizaData(_this.Mode())) {
                        _this.updateFormPersonalizationData();
                    }
                };
                this.onNavigation = function () {
                    var activeForm = $dyn.context($dyn.shell.getActiveForm());
                    if (activeForm && _this._checkIfFormIsNonPersonalizable($dyn.value(activeForm.FormName))) {
                        return;
                    }
                    _this.SystemCloseToolbar();
                };
                this.OnMouseMove = function (event) {
                    var target = event.target || event.srcElement;
                    var mode = _this.Mode ? _this.Mode() : undefined;
                    if (mode && mode === $dyn.ax.personalizationMode.hide && $(target).hasClass($dyn.ui.personalizationClasses.mandatory)) {
                        if (!_this.mandatoryQtip) {
                            $(target).qtip({
                                content: {
                                    text: $dyn.label("FormPersonalization_MandatoryControlHidden")
                                },
                                hide: "unfocus",
                                show: false,
                                style: {
                                    classes: "personalizationTemporarilyVisibleQtip qtip-content baseDirection",
                                },
                            }).qtip("api");
                            _this.mandatoryQtip = $(target).qtip("api");
                            _this.mandatoryQtip.show();
                        }
                        return;
                    }
                    else if (_this.mandatoryQtip) {
                        _this.mandatoryQtip.destroy();
                        _this.mandatoryQtip = null;
                    }
                    var executeNextSteps = _this._showExpandoQtip(event, target);
                    if (executeNextSteps) {
                        if (_this.targetIsInteractable(target)) {
                            // Do not stop events which are not directed at the form being personalized.
                            _this.resetPotentialTarget();
                            return;
                        }
                        if (_this.targetIsClickable(target)) {
                            _this.resetPotentialTarget();
                        }
                        event.stopPropagation();
                        $dyn.log.stopPropagation && $dyn.log.stopPropagation("Stop MouseMove event during Personalization");
                        if (_this.dragTarget && _this.isDragging) {
                            var findTarget = function (targets) {
                                var e_1, _a;
                                try {
                                    for (var targets_1 = __values(targets), targets_1_1 = targets_1.next(); !targets_1_1.done; targets_1_1 = targets_1.next()) {
                                        var currentTarget = targets_1_1.value;
                                        if (_this.selectedForMove) {
                                            var controlElement = _this.getElementOrHeader(_this.selectedForMove.Name, _this.selectedForMove.element);
                                            if (!controlElement.contains(currentTarget)) {
                                                // Find the first element which is not the indicator (i.e. first thing beneath the indicator)
                                                target = currentTarget;
                                                break;
                                            }
                                        }
                                    }
                                }
                                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                                finally {
                                    try {
                                        if (targets_1_1 && !targets_1_1.done && (_a = targets_1.return)) _a.call(targets_1);
                                    }
                                    finally { if (e_1) throw e_1.error; }
                                }
                            };
                            var changedTouches = event.changedTouches;
                            var clientX = changedTouches && changedTouches.length && changedTouches[0].clientX > 0 ? changedTouches[0].clientX : event.clientX;
                            var clientY = changedTouches && changedTouches.length && changedTouches[0].clientY > 0 ? changedTouches[0].clientY : event.clientY;
                            var targetElements = $dyn.util.elementsFromPoint(clientX, clientY);
                            findTarget(targetElements);
                            // Use $dyn.context here - in the case of a React Grid control, targetControl will be undefined and it will find closestControlElement, which is desired
                            var targetControl = $dyn.context(target);
                            if (!targetControl) {
                                // If there is not context for the target, check the DOM heirarchy for the closest control.
                                var closestControlElement = $(target).addBack().closest("[data-dyn-controlname]")[0];
                                targetControl = $dyn.ui.getLiveControl(closestControlElement);
                                if (!targetControl) {
                                    _this.clearApprovedPositionIndicator();
                                    return;
                                }
                            }
                            if (targetControl) {
                                _this.moveTarget = targetControl;
                                _this.moveStart(event);
                            }
                        }
                        if (_this.shouldTarget) {
                            // If the control can be selected:
                            var controlContext = _this.getPersonalizableControl(target);
                            if (controlContext) {
                                if (controlContext.Root && controlContext.Root.UseReactGrid()) {
                                    if (!controlContext.isInGrid() && (_this.potentialTarget === controlContext)) {
                                        // No-op if we are hovering over the current potential target and it is not in the react grid
                                        return;
                                    }
                                }
                                else if (_this.potentialTarget === controlContext) {
                                    // No-op if we are hovering over the current potential target
                                    return;
                                }
                                _this.resetPotentialTarget();
                                // Perform current Mode's hover action.
                                _this.potentialTarget = controlContext;
                                var controlElement = _this.getElementOrHeader(_this.potentialTarget.Name, _this.potentialTarget.element, true);
                                controlElement.classList.add($dyn.ui.personalizationClasses.potentialTarget);
                                $dyn.ax.personalizationUtil.addClassToBreakableGroups(_this.potentialTarget.element, $dyn.ui.personalizationClasses.potentialTarget);
                                return;
                            }
                            _this.resetPotentialTarget();
                        }
                    }
                };
                this.OnKeyDown = function (event) {
                    var target = event.target || event.srcElement;
                    // if the target is in the column header they are filtering in the add field pass the event along
                    // or if the root is the add field dialog
                    var targetContext = $dyn.context(target);
                    if (targetContext && targetContext.Root && _this._isNonPersonalizableForm(targetContext)) {
                        return;
                    }
                    if (!_this.targetIsClickable(target)) {
                        if (!_this._handleKeyDown(target, event)) {
                            event.stopPropagation();
                            $dyn.log.stopPropagation && $dyn.log.stopPropagation("Stop KeyDown event during Personalization");
                            event.preventDefault();
                        }
                    }
                    else if ($dyn.util.isShortcutKeyPressed(event, _this.Shortcuts.ExpandoQtipLeftArrow.Keys) &&
                        _this.secondaryOptionQtip &&
                        _this.secondaryOptionQtip.tooltip &&
                        _this.secondaryOptionQtip.tooltip.find) {
                        $dyn.util.handleShortcuts(_this, event);
                    }
                };
                this.BlockEventHandler = function (event) {
                    var target = event.target || event.srcElement;
                    if (!$dyn.ax.formPersonalizationToolbar.prototype.targetIsInteractable(target) && !$dyn.ax.formPersonalizationToolbar.prototype.targetIsClickable(target)) {
                        // Stop events which are directed at the form being personalized.
                        event.stopPropagation();
                        $dyn.log.stopPropagation && $dyn.log.stopPropagation("Default block event during Personalization");
                    }
                };
                this.currentPersonalizableControls = {};
                this.Mode = $dyn.observable("");
                this.shouldTarget = true;
                this._multiplePersonalizations = {};
                this.AddAPageModeEnabled = $dyn.observable(false);
                this.AddAppModeEnabled = $dyn.observable(false);
                this.AddPowerAppModeEnabled = $dyn.observable(false);
                this.CurrentHelpText = $dyn.observable("");
                this.currentNonPersonalizableControls = {};
                this.currentPersonalizations = {};
                this.currentPersonalizationsControlPropertyMap = {};
                this.CurrentSelectedHelpText = $dyn.observable("");
                this.currentVisibleForms = [];
                this.EventHandler = $dyn.ax.personalizationModeEventHandlers.select;
                this.ExportButtonEnabled = $dyn.observable(false);
                this.htmlLoaded = $.Deferred();
                this.htmlLoading = false;
                this.isDragging = false;
                this.isInitialized = false;
                this.lastPosX = 0;
                this.lastPosY = 0;
                this.MandatoryModeEnabled = $dyn.observable(false);
                this.positionX = 0;
                this.positionY = 0;
                this.PreviewOn = $dyn.observable(false);
                this.setDragTarget = false;
                this.shouldSubTarget = false;
                this.ShowMoreMenu = $dyn.observable(false);
                this._moveTargetZIndex = "1000";
                this.nonPersonalizationForms = {
                    "FormControlFieldSelector": true,
                    "FormRunConfigurationAddApp": true,
                    "FormRunConfigurationAddPAControl": true,
                    "FormRunConfigurationEditPAControl": true,
                    "FormRunConfigurationWebsite": true,
                    "SysCustomFieldAddFieldDialog": true
                };
                this.PropagatedShortcuts = {
                    FactBoxPane: $dyn.controls.Form.prototype.Shortcuts.FactBoxPane,
                    GoToActionPane: $dyn.controls.Form.prototype.Shortcuts.GoToActionPane,
                    GoToFilterPane: $dyn.controls.Form.prototype.Shortcuts.GoToFilterPane,
                    GoToNavigationList: $dyn.controls.Form.prototype.Shortcuts.GoToNavigationList,
                    Personalize: $dyn.controls.Form.prototype.Shortcuts.Personalize,
                };
                $dyn.observe(this.PreviewOn, function (previewOn) {
                    _this.showHiddenFields(!previewOn);
                });
                $dyn.observe(this.Mode, function (mode) { return _this.modeChanged(mode); });
                this.SelectButtonToggled = $dyn.computed(function () {
                    return _this.Mode() === $dyn.ax.personalizationMode.select;
                });
                this.MoveButtonToggled = $dyn.computed(function () {
                    return _this.Mode() === $dyn.ax.personalizationMode.move;
                });
                this.HideButtonToggled = $dyn.computed(function () {
                    return _this.Mode() === $dyn.ax.personalizationMode.hide;
                });
                this.MandatoryButtonToggled = $dyn.computed(function () {
                    return _this.Mode() === $dyn.ax.personalizationMode.mandatory;
                });
                this.TabSummaryButtonToggled = $dyn.computed(function () {
                    return _this.Mode() === $dyn.ax.personalizationMode.addToSummary;
                });
                this.SkipButtonToggled = $dyn.computed(function () {
                    return _this.Mode() === $dyn.ax.personalizationMode.skip;
                });
                this.LockButtonToggled = $dyn.computed(function () {
                    return _this.Mode() === $dyn.ax.personalizationMode.lock;
                });
                this.AddButtonToggled = $dyn.computed(function () {
                    return _this.Mode() === $dyn.ax.personalizationMode.addAField;
                });
                this.AppAppToggled = $dyn.computed(function () {
                    return _this.Mode() === $dyn.ax.personalizationMode.addApp;
                });
                this.AddPAToggled = $dyn.computed(function () {
                    return _this.Mode() === $dyn.ax.personalizationMode.addPAControl;
                });
                this.moreMenu = [
                    {
                        Click: function () { _this.ChangeMode($dyn.ax.personalizationMode.addApp); },
                        HelpText: $dyn.label("FormPersonalization_AddAnApp_ToolTip"),
                        Label: $dyn.label("FormPersonalization_AddAnApp"),
                        Name: "PersonalizationMoreMenuAddApp",
                        Visible: this.AddAppModeEnabled,
                    },
                    {
                        Click: this.AddAPage,
                        HelpText: $dyn.label("FormPersonalization_AddAPage"),
                        Label: $dyn.label("FormPersonalization_AddAPage"),
                        Name: "PersonalizationMoreMenuAddPage",
                        Visible: this.AddAPageModeEnabled,
                    },
                    {
                        Click: function () { _this.ChangeMode($dyn.ax.personalizationMode.addPAControl); },
                        HelpText: $dyn.label("FormPersonalization_AddPA_ToolTip"),
                        Label: $dyn.label("FormPersonalization_AddPA"),
                        Name: "PersonalizationMoreMenuAddPAControl",
                        Visible: this.AddPowerAppModeEnabled,
                    },
                    {
                        Click: this.Clear,
                        HelpText: $dyn.label("FormPersonalization_Clear"),
                        Label: $dyn.label("FormPersonalization_ClearButton"),
                        Name: "PersonalizationMoreMenuClear",
                    },
                    {
                        Click: this.Import,
                        HelpText: $dyn.label("FormPersonalization_Import"),
                        Label: $dyn.label("FormPersonalization_ImportButton"),
                        Name: "PersonalizationMoreMenuImport",
                    },
                    {
                        Click: this.Export,
                        Enabled: this.ExportButtonEnabled,
                        HelpText: $dyn.label("FormPersonalization_Export"),
                        Label: $dyn.label("FormPersonalization_ExportButton"),
                        Name: "PersonalizationMoreMenuExport",
                    }
                ];
                // tslint:disable:object-literal-sort-keys
                this.Shortcuts = {
                    AddAField: {
                        Keys: { keyCode: $dyn.ui.KeyCodes.letterA },
                        Handler: function () {
                            _this.ChangeMode($dyn.ax.personalizationMode.addAField, true);
                        },
                        Description: $dyn.label("FormPersonalization_AddFieldMode")
                    },
                    AddApp: {
                        Keys: { keyCode: $dyn.ui.KeyCodes.letterP },
                        Handler: function () {
                            if ($dyn.value(_this.AddAPageModeEnabled)) {
                                _this.AddAPage();
                            }
                            else if ($dyn.value(_this.AddAppModeEnabled)) {
                                _this.ChangeMode($dyn.ax.personalizationMode.addApp, true);
                            }
                            else if ($dyn.value(_this.AddPowerAppModeEnabled)) {
                                _this.ChangeMode($dyn.ax.personalizationMode.addPAControl, true);
                            }
                        },
                        Description: $dyn.label("FormPersonalization_AddAppMode")
                    },
                    AddToSummaryMode: {
                        Keys: { keyCode: $dyn.ui.KeyCodes.letterU },
                        Handler: function () {
                            _this.ChangeMode($dyn.ax.personalizationMode.addToSummary, true);
                        },
                        Description: $dyn.label("FormPersonalization_SummaryMode")
                    },
                    Clear: {
                        Keys: { ctrl: true, keyCode: $dyn.ui.KeyCodes.letterC },
                        Handler: function () {
                            _this.Clear();
                        },
                        Description: $dyn.label("FormPersonalization_Clear")
                    },
                    Escape: {
                        Keys: { keyCode: $dyn.ui.KeyCodes.esc },
                        Handler: function () {
                            // the toolbar is subscribed to get this event in front of its menu(s) but should allow the flyout handling if a menu is open
                            if (!$dyn.flyout.flyoutManager.areAnyFlyoutsOpen()) {
                                _this.UserCloseToolbar();
                            }
                            _this._destroyExpandoQtip();
                        },
                        Description: $dyn.label("FormPersonalization_Exit")
                    },
                    ExpandoQtipLeftArrow: {
                        Keys: { keyCode: $dyn.ui.KeyCodes.leftArrow },
                        Handler: function () {
                            if (_this.secondaryOptionQtip && _this.secondaryOptionQtip.tooltip && _this.secondaryOptionQtip.tooltip.find) {
                                _this.secondaryOptionQtip.tooltip.find(".secondaryQtipButton").focus();
                            }
                        },
                        Description: $dyn.label("FormPersonalization_ExpandoLeftArrow"),
                        ShowToUser: false,
                    },
                    ExpandoQtipRightArrow: {
                        Keys: { keyCode: $dyn.ui.KeyCodes.rightArrow },
                        Handler: function () {
                            if (_this.secondaryOptionQtip && _this.secondaryOptionQtip.tooltip && _this.currentTargetControl) {
                                _this._focusExpandoTargetElement(_this.currentTargetControl);
                            }
                        },
                        Description: $dyn.label("FormPersonalization_ExpandoRightArrow"),
                        ShowToUser: false,
                    },
                    Export: {
                        Keys: { keyCode: $dyn.ui.KeyCodes.letterX },
                        Handler: function () {
                            _this.Export();
                        },
                        Description: $dyn.label("FormPersonalization_Export")
                    },
                    GoToToolbar: {
                        Keys: { keyCode: $dyn.ui.KeyCodes.letterT },
                        Handler: function () {
                            if ($(document.activeElement).parents(".personalizationToolbar").length === 0) {
                                $dyn.log.focus && $dyn.log.focus("Focus: Focusing personalization toolbar");
                                _this.toggleToolbarFocusTarget = $dyn.ui.removeFocus(undefined);
                                _this.FocusToolbar();
                            }
                            else {
                                if (_this.toggleToolbarFocusTarget) {
                                    $dyn.log.focus && $dyn.log.focus("Focus: Personalization toolbar toggling focus back to last target");
                                    $dyn.ui.restoreFocus(_this.toggleToolbarFocusTarget);
                                }
                                else {
                                    $dyn.log.focus && $dyn.log.focus("Focus: Personalization toolbar toggling focus back to root form");
                                    $dyn.context(_this.rootFormElement).RestoreFocusToMainFormContainer();
                                }
                            }
                        },
                        Description: $dyn.label("FormPersonalization_ToggleFocus")
                    },
                    HideMode: {
                        Keys: { keyCode: $dyn.ui.KeyCodes.letterH },
                        Handler: function () {
                            _this.ChangeMode($dyn.ax.personalizationMode.hide, true);
                        },
                        Description: $dyn.label("FormPersonalization_HideMode")
                    },
                    Import: {
                        Keys: { keyCode: $dyn.ui.KeyCodes.letterI },
                        Handler: function () {
                            _this.Import();
                        },
                        Description: $dyn.label("FormPersonalization_Import")
                    },
                    LockMode: {
                        Keys: { keyCode: $dyn.ui.KeyCodes.letterE },
                        Handler: function () {
                            _this.ChangeMode($dyn.ax.personalizationMode.lock, true);
                        },
                        Description: $dyn.label("FormPersonalization_LockMode")
                    },
                    MandatoryMode: {
                        Keys: { keyCode: $dyn.ui.KeyCodes.letterR },
                        Handler: function () {
                            if ($dyn.value(_this.MandatoryModeEnabled)) {
                                _this.ChangeMode($dyn.ax.personalizationMode.mandatory, true);
                            }
                        },
                        Description: $dyn.label("FormPersonalization_MandatoryMode")
                    },
                    MoveMode: {
                        Keys: { keyCode: $dyn.ui.KeyCodes.letterM },
                        Handler: function () {
                            _this.ChangeMode($dyn.ax.personalizationMode.move, true);
                        },
                        Description: $dyn.label("FormPersonalization_MoveMode")
                    },
                    SelectMode: {
                        Keys: { keyCode: $dyn.ui.KeyCodes.letterS },
                        Handler: function () {
                            _this.ChangeMode($dyn.ax.personalizationMode.select, true);
                        },
                        Description: $dyn.label("FormPersonalization_SelectMode")
                    },
                    SkipMode: {
                        Keys: { keyCode: $dyn.ui.KeyCodes.letterK },
                        Handler: function () {
                            _this.ChangeMode($dyn.ax.personalizationMode.skip, true);
                        },
                        Description: $dyn.label("FormPersonalization_SkipMode")
                    },
                };
                // tslint:enable:object-literal-sort-keys
                this.isInitialized = true;
            }
            // Root level toolbar helper functions
            formPersonalizationToolbar.prototype.LaunchToolbar = function (callback) {
                var _this = this;
                this.ensureLoaded();
                $.when(this.htmlLoaded).done(function () { return _this.initToolBar(callback); });
            };
            // Manage Personalizations
            formPersonalizationToolbar.prototype.savePendingPersonalizationAndCallUpdatePersonalizationData = function (forceGetVisibleForms) {
                this.SavePendingPersonalization();
                this.updateFormPersonalizationData(forceGetVisibleForms);
            };
            // Control/target interaction
            formPersonalizationToolbar.prototype.getElementOrHeader = function (controlName, controlElement, findInnerControl) {
                if (findInnerControl === void 0) { findInnerControl = false; }
                // Gets the header element of the control or returns the control element if there is no header.
                var header = $($dyn.ui.selector().attr("data-dyn-mappedtab", controlName).toString())[0];
                var element = header ? header : controlElement;
                if ($dyn.util.isFlightEnabled($dyn.reactGrid.featureName)) {
                    if (findInnerControl) {
                        // For the React Grid, element may be the outer cell container, so get the real control element
                        if (element && element.classList.contains("fixedDataTableCellLayout_main")) {
                            controlElement = $(element).find("[data-dyn-controlname]")[0];
                            if (controlElement) {
                                element = controlElement;
                            }
                        }
                    }
                    else {
                        var context_1 = $dyn.ui.getLiveControl(controlElement);
                        if (context_1 && context_1.isInGrid && context_1.isInGrid() && context_1.Root && context_1.Root.UseReactGrid()) {
                            // For the React Grid, get the outer cell element for styling purposes
                            var outerCellContainer = $(controlElement).closest(".public_fixedDataTableCell_main")[0];
                            if (outerCellContainer) {
                                element = outerCellContainer;
                            }
                        }
                    }
                }
                return element;
            };
            formPersonalizationToolbar.prototype.resetPotentialTarget = function () {
                $($dyn.ui.selector().css($dyn.ui.personalizationClasses.potentialTarget).toString()).removeClass($dyn.ui.personalizationClasses.potentialTarget);
                this.potentialTarget = undefined;
            };
            // Mode specific functions
            formPersonalizationToolbar.prototype.SelectForEditPAControl = function (control) {
                $dyn.callFunction(control.ExecutePersonalizationCommand, control, ["SelectForEditPAControl"]);
            };
            formPersonalizationToolbar.prototype.SelectForEditWebsiteHostControl = function (control) {
                $dyn.callFunction(control.ExecutePersonalizationCommand, control, ["SelectForEditWebsiteHostControl"]);
            };
            formPersonalizationToolbar.prototype.SelectForQuickPersonalization = function (control) {
                var _this = this;
                if (control) {
                    if (!$dyn.ax.formPersonalizationPane.formPersonalizationController.qtip) {
                        this.shouldTarget = false;
                        $dyn.ax.formPersonalizationPane.formPersonalizationController.openPersonalizationUI(control);
                        var subscriptionId_1;
                        subscriptionId_1 = $dyn.ax.formPersonalizationPane.qTipDestroyed.subscribe(function () {
                            _this.shouldTarget = true;
                            $dyn.ax.formPersonalizationPane.qTipDestroyed.unsubscribe(subscriptionId_1);
                        });
                    }
                }
                else {
                    $dyn.logError("formPersonalization: control passed as null in SelectForQuickPersonalization");
                }
            };
            formPersonalizationToolbar.prototype.SelectForHide = function (control) {
                // Check for Parents
                // We will ignore click on Child controls if Parent has hidden class
                var parentControl;
                if (control._parent) {
                    parentControl = control._parent;
                }
                else if ($(control.element).parent()[0]) {
                    parentControl = $(control.element).parent()[0];
                }
                else {
                    parentControl = $(control).parent()[0];
                }
                while (parentControl) {
                    var elementToCheck = parentControl.element ? parentControl.element : parentControl;
                    if ((elementToCheck).classList && elementToCheck.classList.contains($dyn.ui.personalizationClasses.hidden)) {
                        return;
                    }
                    if (parentControl._parent) {
                        parentControl = parentControl._parent;
                    }
                    else if ($(parentControl.element).parent()[0]) {
                        parentControl = $(parentControl.element).parent()[0];
                    }
                    else {
                        parentControl = $(parentControl).parent()[0];
                    }
                }
                var newPropertyValue = control.element.classList.contains($dyn.ui.personalizationClasses.personalized) ? "True" : "False";
                // Handle For Childs
                if (newPropertyValue === "False") {
                    this.HandleHideForChildControls(control, false);
                }
                var formName = control.Root.FormName;
                this.ApplyPersonalizations(formName, $dyn.ax.personalizableProperties.Visible, newPropertyValue, control);
            };
            formPersonalizationToolbar.prototype.SelectForAddToSummary = function (control) {
                var formName = control.Root.FormName;
                var newPropertyValue = control.element.classList.contains($dyn.ui.personalizationClasses.personalized) ? "False" : "True";
                this.ApplyPersonalizations(formName, $dyn.ax.personalizableProperties.FastTabSummary, newPropertyValue, control);
            };
            formPersonalizationToolbar.prototype.SelectForSkip = function (control) {
                var formName = control.Root.FormName;
                var newPropertyValue = control.element.classList.contains($dyn.ui.personalizationClasses.personalized) ? "True" : "False";
                this.ApplyPersonalizations(formName, $dyn.ax.personalizableProperties.CanFocus, newPropertyValue, control);
            };
            formPersonalizationToolbar.prototype.SelectForLock = function (control) {
                var formName = control.Root.FormName;
                var newPropertyValue = control.element.classList.contains($dyn.ui.personalizationClasses.personalized) ? "True" : "False";
                this.ApplyPersonalizations(formName, $dyn.ax.personalizableProperties.AllowEdit, newPropertyValue, control);
            };
            formPersonalizationToolbar.prototype.SelectForMandatory = function (control) {
                var formName = control.Root.FormName;
                var newPropertyValue = control.element.classList.contains($dyn.ui.personalizationClasses.personalized) ? "False" : "True";
                this.ApplyPersonalizations(formName, $dyn.ax.personalizableProperties.Mandatory, newPropertyValue, control);
            };
            formPersonalizationToolbar.prototype.SelectForAdd = function (control) {
                $dyn.callFunction(control.ExecutePersonalizationCommand, control, ["SelectForAdd"]);
            };
            formPersonalizationToolbar.prototype.SelectForAddPAControl = function (control) {
                $dyn.callFunction(control.ExecutePersonalizationCommand, control, ["SelectForAddPAControl"]);
            };
            formPersonalizationToolbar.prototype.SelectForAddApp = function (control) {
                $dyn.callFunction(control.ExecutePersonalizationCommand, control, ["SelectForAddApp"]);
            };
            formPersonalizationToolbar.prototype.SelectForMove = function (control, isFromDrag, dragEvent) {
                var _this = this;
                if (isFromDrag === void 0) { isFromDrag = false; }
                if (!this.selectedForMove && control) {
                    // Step 1 select the control to move
                    this.selectedForMove = control;
                    this.shouldTarget = false;
                    this.shouldSubTarget = true;
                    var controlElement = this.getElementOrHeader(this.selectedForMove.Name, this.selectedForMove.element);
                    controlElement.classList.add($dyn.ui.personalizationClasses.selectedForMove);
                    if (this.setDragTarget) {
                        this.dragTarget = controlElement;
                    }
                    $dyn.ax.personalizationUtil.addClassToBreakableGroups(controlElement, $dyn.ui.personalizationClasses.selectedForMove);
                    this.updateAccessibilityDescriptionForMove(true);
                    this.currentApprovedPositions = [];
                    // Send this contol to the server and get back the list of the available positions this control can move to
                    $dyn.callFunction(this.selectedForMove.ExecutePersonalizationCommand, this.selectedForMove, ["SelectForMove"], function () {
                        var e_2, _a;
                        if (_this.selectedForMove) {
                            // When the positions are calculated, parse the forms' personalizationData to read the indecies.
                            var form = _this.selectedForMove.Root;
                            // positions is an array of strings of the format "<Parent>,<ChildBefore>"
                            var personalizationPositions = JSON.parse(form.PersonalizationData());
                            _this.currentApprovedPositions = [];
                            _this.currentApprovedPositions.formName = form.FormName;
                            _this.currentPosition = undefined;
                            try {
                                for (var personalizationPositions_1 = __values(personalizationPositions), personalizationPositions_1_1 = personalizationPositions_1.next(); !personalizationPositions_1_1.done; personalizationPositions_1_1 = personalizationPositions_1.next()) {
                                    var positions = personalizationPositions_1_1.value;
                                    var position = positions.split(",");
                                    _this.currentApprovedPositions.push(position);
                                }
                            }
                            catch (e_2_1) { e_2 = { error: e_2_1 }; }
                            finally {
                                try {
                                    if (personalizationPositions_1_1 && !personalizationPositions_1_1.done && (_a = personalizationPositions_1.return)) _a.call(personalizationPositions_1);
                                }
                                finally { if (e_2) throw e_2.error; }
                            }
                            if (_this.shouldSubTarget && isFromDrag) {
                                _this.EventHandler.subTarget(_this, _this.moveTarget, dragEvent);
                            }
                        }
                    });
                }
                else if (this.selectedForMove) {
                    // Step 2 move the control to the currently selected position
                    if (this.currentPosition !== undefined && this.currentApprovedPositions && this.currentApprovedPositions[this.currentPosition]) {
                        var positionStr = this.currentApprovedPositions[this.currentPosition].join(",");
                        $dyn.callFunction(this.selectedForMove.ExecutePersonalizationCommand, this.selectedForMove, ["MoveControl", positionStr], function reflowAfterMove() {
                            $dyn.layout.reflowRootForm();
                        });
                    }
                    // We need to set this flag for resetting move classes, however, we can not do it now as we want OnClick function to be called and stop event propagations before move is reset
                    $dyn.async(function () {
                        _this.resetMove();
                    }, undefined, "Reset move only after onclick is fired so that it can stop onclick propagation");
                }
                else {
                    // Error case. should not be here
                }
            };
            // Move Mode specific functions
            formPersonalizationToolbar.prototype.resetMove = function () {
                if (this.selectedForMove) {
                    this.selectedForMove = undefined;
                    $($dyn.ui.selector().css($dyn.ui.personalizationClasses.selectedForMove).toString()).removeClass($dyn.ui.personalizationClasses.selectedForMove);
                    this.updateAccessibilityDescriptionForMove();
                }
                if (this.draggableObject) {
                    this.draggableObject.destroy();
                    this.draggableObject = undefined;
                }
                this.shouldTarget = true;
                this.shouldSubTarget = false;
                this.resetDragTarget();
                this.clearApprovedPositionIndicator();
            };
            formPersonalizationToolbar.prototype.UpdateMoveToLocationKeyboard = function (event) {
                if (!this.selectedForMove) {
                    return;
                }
                var numberOfPositions = this.currentApprovedPositions.length;
                if (numberOfPositions === 0) {
                    return;
                }
                var keyCode = event.which;
                var direction = 0;
                if (keyCode === $dyn.ui.KeyCodes.upArrow || keyCode === $dyn.ui.KeyCodes.leftArrow || (keyCode === $dyn.ui.KeyCodes.tab && event.shiftKey)) {
                    // Up, Left, and Shift+Tab are Back navigations
                    direction = -1;
                }
                else if (keyCode === $dyn.ui.KeyCodes.downArrow || keyCode === $dyn.ui.KeyCodes.rightArrow || (keyCode === $dyn.ui.KeyCodes.tab && !event.shiftKey)) {
                    // Down, Right, and Tab are Forward navigations
                    direction = 1;
                }
                else {
                    return;
                }
                if (this.currentPosition === undefined) {
                    var selectedForMoveIndex = this.currentApprovedPositions.map(function (position) {
                        return position[1];
                    }).indexOf(this.selectedForMove.Name);
                    if (direction === 1) {
                        // if the move is forward, then set the current position to the place of the selectedForMove
                        this.currentPosition = selectedForMoveIndex;
                    }
                    else if (direction === -1) {
                        // if the move is backards, then set the current position to the place before the selectedForMove
                        this.currentPosition = selectedForMoveIndex ? selectedForMoveIndex - 1 : numberOfPositions - 1;
                    }
                }
                var newPosition;
                if (this.currentPosition === 0 && direction === -1) {
                    newPosition = numberOfPositions - 1;
                }
                else {
                    newPosition = (this.currentPosition + direction) % numberOfPositions;
                }
                this.currentPosition = newPosition;
                this.highlightCurrentApprovedPosition();
            };
            formPersonalizationToolbar.prototype.UpdateMoveToLocation = function (control, event) {
                var positionIndex;
                var controlName = "";
                if (control) {
                    var currentContext = void 0;
                    var currentTarget = control.element;
                    // Check if valid move location
                    // Move up the DOM unitl we find a control which we can move before/after.
                    // This is needed for the senario where a part form is mingled with other controls and we want to
                    // move the control with regard to the part control and not any of its nested content
                    while (positionIndex === undefined && currentTarget) {
                        currentContext = $dyn.ui.getLiveControl(currentTarget);
                        controlName = currentContext && currentContext.Name;
                        for (var i = 0; i < this.currentApprovedPositions.length && controlName; i++) {
                            var position = this.currentApprovedPositions[i];
                            if (position[1] === controlName) {
                                positionIndex = i;
                                break;
                            }
                        }
                        if (positionIndex === undefined) {
                            currentTarget = currentTarget.parentElement;
                        }
                    }
                    control = $dyn.ui.getLiveControl(currentTarget);
                }
                if (!control || positionIndex === undefined || controlName === this.selectedForMove.Name) {
                    this.currentPosition = undefined;
                    this.clearApprovedPositionIndicator();
                    return;
                }
                // Check if the target is in the first or second half of the control (Top/Bottom by default, Left/Right for items in Grid,Table,Panorama,etc...)
                if (this.mouseIsOverFirstHalfOfControl(control, event)) {
                    // The mouse is over the first half of the control (i.e. the move is to be AFTER the control PREVIOUS to this one.)
                    // Move the index left until we find the previous instance of the current position's parent
                    var position = this.currentApprovedPositions[positionIndex];
                    var parentName = position[0];
                    positionIndex && positionIndex--;
                    var prevIndexParent = this.currentApprovedPositions[positionIndex][0];
                    while (positionIndex > 0 && prevIndexParent !== parentName) {
                        positionIndex--;
                        prevIndexParent = this.currentApprovedPositions[positionIndex][0];
                    }
                }
                // Check if we are over the left side of the element to the right of the control we are moving
                if (this.currentApprovedPositions[positionIndex][1] === this.selectedForMove.Name) {
                    return;
                }
                // Check if we are over the right side of the element to the left of the control we are moving
                if (this.currentApprovedPositions[positionIndex + 1] && this.currentApprovedPositions[positionIndex + 1][1] === this.selectedForMove.Name) {
                    return;
                }
                this.currentPosition = positionIndex;
                this.highlightCurrentApprovedPosition();
            };
            // Root level toolbar button functions
            formPersonalizationToolbar.prototype.modeChanged = function (mode) {
                if (!this.isInitialized || mode === "") {
                    return;
                }
                // update displayed help text
                this.CurrentSelectedHelpText(this.CurrentHelpText());
                this.setDragTarget = false;
                this.resetDragTarget();
                this.resetMove();
                this.PreviewOn(true);
                if (mode === $dyn.ax.personalizationMode.hide) {
                    this.PreviewOn(false);
                }
                this.updateFormPersonalizationData();
                if (mode === $dyn.ax.personalizationMode.move) {
                    this.setDragTarget = true;
                }
                if (mode === $dyn.ax.personalizationMode.addAField) {
                    this.getPersonalizableControl = $dyn.ax.personalizationUtil.getPersonalizableContainerControl;
                }
                else if (mode === $dyn.ax.personalizationMode.addPAControl || mode === $dyn.ax.personalizationMode.addApp) {
                    this.getPersonalizableControl = $dyn.ax.personalizationUtil.getPersonalizableAppContainerControl;
                }
                else {
                    this.getPersonalizableControl = $dyn.ax.personalizationUtil.getPersonalizableControl;
                }
                this.EventHandler = $dyn.ax.personalizationModeEventHandlers[mode];
            };
            formPersonalizationToolbar.prototype.SendToolbarAction = function (mode) {
                var form = this.currentVisibleForms[0]; // Get only the root
                if (form) {
                    $dyn.callFunction(form.ExecutePersonalizationCommand, form, ["ToolbarAction_" + mode]);
                    // special case the open command to close a unique form we want closed
                    if (mode === $dyn.ax.personalizationMode.open) {
                        var activeForm_1 = $dyn.context($dyn.shell.getActiveForm());
                        if (activeForm_1 && activeForm_1.FormName === "FormRunConfigurationViewSelection") {
                            $dyn.getFunction(activeForm_1.Close)();
                        }
                    }
                }
            };
            // Root level toolbar helper functions
            /**
             * Handler function for when htmlLoaded field is resolved
             * @param callback Call back function to be called
             */
            formPersonalizationToolbar.prototype.initToolBar = function (callback) {
                var _this = this;
                if (!this.toolbar) {
                    this.toolbar = $dyn.ui.createControl("PersonalizationToolbar", this);
                }
                if (!this.TabbingHandlerDispose) {
                    this.TabbingHandlerDispose = $dyn.util.tabbingContainer(this.toolbar, $dyn.label("FormPersonalization_RegionTitle"));
                }
                // clear out the help text holder
                this.CurrentHelpText("");
                this.potentialTarget = undefined;
                this.shouldTarget = true;
                this.shouldSubTarget = false;
                this.selectedForMove = undefined;
                this.getPersonalizableControl = $dyn.ax.personalizationUtil.getPersonalizableControl;
                this.ShowMoreMenu(false);
                if (this.toolbar.style.visibility !== "visible") {
                    var host = document.getElementById("mainPane");
                    !this.toolbar.parentNode && host.appendChild(this.toolbar);
                    // Only reposition and setup the toolbar if it is not currently visible
                    this.rootFormElement = $dyn.shell.getCurrentDialog() || $dyn.shell.getCurrentRootForm();
                    var rootForm = $dyn.context(this.rootFormElement);
                    this.getCurrentlyVisibleForms(rootForm);
                    this.SendToolbarAction($dyn.ui.personalizationToolbarEvents.ActionOpen);
                    this._positionToolbar();
                    this.toolbar.style.visibility = "visible";
                    this.Mode($dyn.ax.personalizationMode.select, true);
                    // set initial current help text for the toolbar visual
                    var elm = $dyn.context($(this.toolbar).find('[aria-pressed="true"]')[0]);
                    if (elm && elm.HelpText) {
                        this.CurrentHelpText($dyn.value(elm.HelpText));
                    }
                    this.CurrentSelectedHelpText(this.CurrentHelpText());
                    this.addHandlers();
                }
                $dyn.shell.disableContextMenu = true;
                this._navigationCompleteEventSubscriberID = $dyn.shell.subscribeToNavigationCompleteEvent(this.onNavigation);
                $(document.body).on("resetShellOnNavigation.formPersonalization", this.onNavigation);
                $.when($dyn.deferred.onTrue(function () { return !$dyn.clientBusy(); })).done(function () {
                    _this.FocusToolbar();
                    var toolBarDragElement = document.getElementsByClassName("personalizationToolbarGripper")[0];
                    if (toolBarDragElement) {
                        _this.toolBarDragElement_hammer = new Hammer(toolBarDragElement);
                        _this.toolBarDragElement_hammer.add(new Hammer.Pan({ direction: Hammer.DIRECTION_ALL, threshold: 0 }));
                        _this.toolBarDragElement_hammer.on("pan", function (event) { return _this.handleDrag(event); });
                        _this.lastPosX = toolBarDragElement.offsetLeft;
                        _this.lastPosY = toolBarDragElement.offsetTop;
                    }
                    if ($dyn.value(_this.AddAppModeEnabled)) {
                        var moreButtonGroupElement = document.getElementById("PersonalizationToolbar_More");
                        var moreButtonGroup = $dyn.context(moreButtonGroupElement);
                        if (moreButtonGroup) {
                            moreButtonGroup.HelpText = $dyn.label("FormPersonalization_MoreButton_ToolTip_AppsFlight");
                        }
                    }
                });
                if (callback) {
                    callback();
                }
            };
            formPersonalizationToolbar.prototype.ensureLoaded = function () {
                var _this = this;
                if (this.htmlLoaded.state() !== "resolved" && !this.htmlLoading) {
                    this.htmlLoading = true;
                    $dyn.requireResourceBundle("/resources/templates/FormPersonalization", function () {
                        _this.htmlLoading = false;
                        _this.htmlLoaded.resolve();
                    });
                }
            };
            formPersonalizationToolbar.prototype.FocusToolbar = function () {
                // Focuses the first button of the Toolbar.
                $(this.toolbar).find(".personalizationToolbar-symbolButton").first().focus();
            };
            formPersonalizationToolbar.prototype.closeToolbarCleanup = function () {
                this.SavePendingPersonalization();
                this.toolbar.style.visibility = "hidden";
                var host = document.getElementById("mainPane");
                this.toolbar.parentNode && host && host.removeChild(this.toolbar);
                this.removeHandlers();
                this.removeNavigationHandlers();
                this.resetPotentialTarget();
                this.resetIndicators();
                this.clearRootForm();
                if (this.Mode() === $dyn.ax.personalizationMode.move) {
                    this.resetMove();
                }
                this.PreviewOn(true);
                this.Mode("");
                if (this.toolBarDragElement_hammer) {
                    this.toolBarDragElement_hammer.destroy();
                }
                $(window).trigger($dyn.ui.personalizationToolbarEvents.ToolbarClosed, [this]);
                $dyn.shell.disableContextMenu = false;
            };
            formPersonalizationToolbar.prototype.SystemCloseToolbar = function () {
                // Order of calling closeToolbarCleanup is important as closeToolbarCleanup calls SavePendingPersonalization
                // And that has to go first for task recorder steps to be in order
                this.closeToolbarCleanup();
                this.SendToolbarAction($dyn.ui.personalizationToolbarEvents.ActionSystemClose);
            };
            formPersonalizationToolbar.prototype.setToolbarControlButtonState = function () {
                var toolBarControl = $dyn.ui.findControl("__PersonalizationToolbar", this.rootFormElement);
                if (toolBarControl) {
                    if (toolBarControl.IsExportEnabled) {
                        this.ExportButtonEnabled(toolBarControl.IsExportEnabled());
                    }
                    if (toolBarControl.IsAddAppModeEnabled) {
                        this.AddAppModeEnabled(toolBarControl.IsAddAppModeEnabled());
                    }
                    if (toolBarControl.IsAddAPageModeEnabled) {
                        this.AddAPageModeEnabled(toolBarControl.IsAddAPageModeEnabled());
                    }
                    if (toolBarControl.IsAddPowerAppModeEnabled) {
                        this.AddPowerAppModeEnabled(toolBarControl.IsAddPowerAppModeEnabled());
                    }
                    if (toolBarControl.IsMandatoryModeEnabled) {
                        this.MandatoryModeEnabled(toolBarControl.IsMandatoryModeEnabled());
                    }
                }
            };
            formPersonalizationToolbar.prototype._canUpdateFormPersonalizaData = function (mode) {
                return mode !== $dyn.ax.personalizationMode.move && mode !== $dyn.ax.personalizationMode.addAField &&
                    mode !== $dyn.ax.personalizationMode.hide && mode !== $dyn.ax.personalizationMode.lock &&
                    mode !== $dyn.ax.personalizationMode.skip && mode !== $dyn.ax.personalizationMode.addToSummary &&
                    mode !== $dyn.ax.personalizationMode.mandatory;
            };
            formPersonalizationToolbar.prototype.showHiddenFields = function (showHiddenFields) {
                var e_3, _a;
                try {
                    for (var _b = __values(this.currentVisibleForms), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var form = _c.value;
                        if (form && form.ShowOrHideHiddenFields) {
                            form.ShowOrHideHiddenFields(showHiddenFields);
                        }
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
            };
            formPersonalizationToolbar.prototype._getSymbolClass = function (mode) {
                var symbolClass = "";
                switch (mode) {
                    case $dyn.ax.personalizationMode.select:
                        symbolClass = $dyn.ui.personalizationModeSymbolClasses.Click;
                        break;
                    case $dyn.ax.personalizationMode.move:
                        symbolClass = $dyn.ui.personalizationModeSymbolClasses.Move;
                        break;
                    case $dyn.ax.personalizationMode.hide:
                        symbolClass = $dyn.ui.personalizationModeSymbolClasses.HideItem;
                        break;
                    case $dyn.ax.personalizationMode.addToSummary:
                        symbolClass = $dyn.ui.personalizationModeSymbolClasses.SummaryField;
                        break;
                    case $dyn.ax.personalizationMode.skip:
                        symbolClass = $dyn.ui.personalizationModeSymbolClasses.SkipTab;
                        break;
                    case $dyn.ax.personalizationMode.lock:
                        symbolClass = $dyn.ui.personalizationModeSymbolClasses.Uneditable;
                        break;
                    default:
                        symbolClass = $dyn.ui.personalizationModeSymbolClasses.Click;
                        break;
                }
                return symbolClass;
            };
            formPersonalizationToolbar.prototype.handleDrag = function (ev) {
                // grab the toolbar element
                var elem = this.toolbar;
                // DRAG STARTED
                if (!this.isDragging) {
                    this.isDragging = true;
                    this.lastPosX = elem.offsetLeft;
                    this.lastPosY = elem.offsetTop;
                }
                var posX = ev.deltaX + this.lastPosX;
                var posY = ev.deltaY + this.lastPosY;
                // move our element to that position
                // is there enough space to move right
                if (($(window).width() - (posX + this.toolbar.offsetWidth)) > 0) {
                    elem.style.left = posX < 0 ? 0 + "px" : posX + "px";
                }
                // is there enough space to move down
                if (($(window).height() - (posY + this.toolbar.offsetHeight)) > 0) {
                    elem.style.top = posY < 0 ? 0 + "px" : posY + "px";
                }
                // DRAG ENDED
                if (ev.isFinal) {
                    this.isDragging = false;
                }
            };
            formPersonalizationToolbar.prototype._positionToolbar = function () {
                // Positions the toolbar for when it is displayed
                this.toolbar.style.top = "";
                var leftOffset = $(window).width() / 2 - $(this.toolbar).width() / 2;
                this.toolbar.style.left = leftOffset + "px";
            };
            formPersonalizationToolbar.prototype.canModeHandleKey = function (event) {
                var keyCode = event.which;
                return this.EventHandler && this.EventHandler.acceptedKeyCodes.indexOf(keyCode) !== -1;
            };
            // Event Handler helper functions
            formPersonalizationToolbar.prototype.addHandlers = function () {
                // Adds window level handlers to capture events at the document level on capture phase
                // This should remove the ability to interact with the form when the toolbar is up.
                this.throttledOnMouseMove = $dyn.ax.personalizationUtil.throttle(this.OnMouseMove, 50);
                this.throttledOnKeyDown = $dyn.ax.personalizationUtil.throttle(this.OnKeyDown, 10, true);
                document.body.addEventListener("touchmove", this.throttledOnMouseMove, true);
                document.body.addEventListener("mousemove", this.throttledOnMouseMove, true);
                document.body.addEventListener("click", this.OnClick, true);
                document.body.addEventListener("keydown", this.throttledOnKeyDown, true);
                document.body.addEventListener("touchenter", this.BlockEventHandler, true);
                document.body.addEventListener("mouseenter", this.BlockEventHandler, true);
                document.body.addEventListener("focus", this.OnFocus, true);
                var toolbarButtonTemp = this.toolbar.getElementsByClassName("button");
                // for..of not in use due to toolbarButtonTemp being of the type HTMLCollectionOf
                // for..in can be used but requires an if statement within the loop
                // tslint:disable-next-line:prefer-for-of
                for (var i = 0; i < toolbarButtonTemp.length; i++) {
                    $(toolbarButtonTemp[i]).on("mouseenter.toolbar", this.updateCurrentHelpText);
                    $(toolbarButtonTemp[i]).on("focus.toolbar", this.updateCurrentHelpText);
                }
                this.toolbar.addEventListener("mouseleave", this.updateCurrentHelpText);
            };
            formPersonalizationToolbar.prototype.removeHandlers = function () {
                // Removes bound handlers
                document.body.removeEventListener("touchmove", this.throttledOnMouseMove, true);
                document.body.removeEventListener("mousemove", this.throttledOnMouseMove, true);
                document.body.removeEventListener("click", this.OnClick, true);
                document.body.removeEventListener("keydown", this.throttledOnKeyDown, true);
                document.body.removeEventListener("touchenter", this.BlockEventHandler, true);
                document.body.removeEventListener("mouseenter", this.BlockEventHandler, true);
                document.body.removeEventListener("focus", this.OnFocus, true);
                var toolbarButtonTemp = this.toolbar.getElementsByClassName("button");
                // tslint:disable-next-line:prefer-for-of
                for (var i = 0; i < toolbarButtonTemp.length; i++) {
                    $(toolbarButtonTemp[i]).off(".toolbar");
                }
                this.toolbar.removeEventListener("mouseleave", this.updateCurrentHelpText);
            };
            formPersonalizationToolbar.prototype.removeNavigationHandlers = function () {
                $(document.body).off("resetShellOnNavigation.formPersonalization");
                this._navigationCompleteEventSubscriberID && $dyn.shell.unsubscribeToNavigationCompleteEvent(this._navigationCompleteEventSubscriberID);
                this._navigationCompleteEventSubscriberID = undefined;
                if (this.TabbingHandlerDispose) {
                    this.TabbingHandlerDispose();
                    this.TabbingHandlerDispose = undefined;
                }
            };
            /**
             * Handle key down event
             * JQueryKeyEventObject must be used in place of KeyboardEvent due to the call to $dyn.util.handleShortcuts
             * @param target HTML element event was performed on
             * @param event Event that was performed
             */
            formPersonalizationToolbar.prototype._handleKeyDown = function (target, event) {
                var key = event.which;
                var propagateFromModeToToolbar = true;
                var propagateOutsidePersonalization = false;
                var controlElement = this.getPersonalizableControl(target);
                if (controlElement && this.canModeHandleKey(event)) {
                    propagateFromModeToToolbar = this.EventHandler.onKeyDown(this, controlElement, event);
                }
                if (propagateFromModeToToolbar === true) {
                    if ($dyn.ax.formPersonalizationPane.formPersonalizationController.qtip) {
                        if ($dyn.util.isShortcutKeyPressed(event, this.Shortcuts.Escape.Keys)) {
                            $dyn.ax.formPersonalizationPane.formPersonalizationController.destroyQTip();
                        }
                    }
                    else {
                        $dyn.util.handleShortcuts(this, event);
                    }
                    $.each(this.PropagatedShortcuts, function (name, shortcut) {
                        if ($dyn.util.isShortcutKeyPressed(event, shortcut.Keys)) {
                            propagateOutsidePersonalization = true;
                            // break
                            return false;
                        }
                    });
                    var isRefreshBrowser = key === $dyn.ui.KeyCodes.f5;
                    var targetIsInteractable = this.targetIsInteractable(target);
                    var targetIsClickable = this.targetIsClickable(target);
                    var isAllowedTabbing = key === $dyn.ui.KeyCodes.tab && !this.shouldSubTarget;
                    propagateOutsidePersonalization = propagateOutsidePersonalization || isRefreshBrowser || targetIsInteractable || isAllowedTabbing || targetIsClickable;
                }
                if (propagateFromModeToToolbar === false || propagateOutsidePersonalization === false) {
                    return false;
                }
                return true;
            };
            // Move Mode specific functions
            /**
             * Called on start of a move originated by mousedown event.
             * @param event originating the move
             */
            formPersonalizationToolbar.prototype.moveStart = function (event) {
                if ($dyn.util.isFlightEnabled($dyn.reactGrid.featureName)) {
                    this.dragTarget = this.getElementOrHeader(null, this.dragTarget, true);
                }
                var control = this.getPersonalizableControl(this.dragTarget);
                this.selectedForMove = undefined;
                this.SelectForMove(control, true, event);
                // Cancel the shell's extended event loop since we need the command to fire before our mouseup will occur.
                $dyn.shell.cancelExtendedEventLoop();
            };
            /**
             * Called on stop of a move origantaed by mouseup event.
             */
            formPersonalizationToolbar.prototype.moveStop = function () {
                this.SelectForMove();
            };
            formPersonalizationToolbar.prototype.mouseIsOverFirstHalfOfControl = function (control, event) {
                var element = this.getElementOrHeader(control.Name, control.element);
                var offset = $(element).offset();
                var min = offset && offset.top;
                var max = min + $(element).outerHeight();
                var changedTouches = event.changedTouches;
                var mouseLoc = changedTouches && changedTouches.length && changedTouches[0].clientY > 0 ? changedTouches[0].clientY : event.clientY;
                if (this.controlLayoutHorizontal(control)) {
                    min = offset && offset.left;
                    max = min + $(element).outerWidth();
                    mouseLoc = changedTouches && changedTouches.length && changedTouches[0].clientX > 0 ? changedTouches[0].clientX : event.clientX;
                }
                return mouseLoc < (min + max) / 2;
            };
            formPersonalizationToolbar.prototype.resetDragTarget = function () {
                this.dragTarget = undefined;
                this.moveTarget = undefined;
            };
            // Element Evaluation
            formPersonalizationToolbar.prototype._checkIfFormIsNonPersonalizable = function (formName) {
                var isNonPersonalizationForm = false;
                if (this.nonPersonalizationForms[formName]) {
                    isNonPersonalizationForm = true;
                }
                return isNonPersonalizationForm;
            };
            formPersonalizationToolbar.prototype._isNonPersonalizableForm = function (targetContext) {
                var isNonPersonalizationForm = false;
                if (targetContext &&
                    targetContext.Root &&
                    (this._checkIfFormIsNonPersonalizable(targetContext.Root.FormName) ||
                        (targetContext.Root.Root &&
                            this._checkIfFormIsNonPersonalizable(targetContext.Root.Root.FormName)))) {
                    isNonPersonalizationForm = true;
                }
                return isNonPersonalizationForm;
            };
            formPersonalizationToolbar.prototype.targetIsPersonalizing = function (target) {
                return 0 !== $(target).addBack().closest($dyn.ui.selector().css($dyn.ui.personalizationClasses.isPersonalizing).toString()).length;
            };
            formPersonalizationToolbar.prototype.targetIsInteractable = function (target) {
                // Check that the target is not nested under the root form which is currently being personalized
                // or that it is not under the navBar, asidePane, or modulesPane
                var controlName = $dyn.context(target) ? $dyn.context(target).TypeName : "";
                var isFactBoxPaneToggleButton = $dyn.context(target) && $dyn.context(target).Name === "FactBoxToggleExpand";
                var targetIsInteractable = ((!this.targetIsPersonalizing(target)
                    && !$(target).addBack().closest(".navigationBar").length
                    && !$(target).addBack().closest(".asidePane").length
                    && !$(target).addBack().closest(".modulesPane").length)) || (controlName === "OverflowButton") || isFactBoxPaneToggleButton;
                return targetIsInteractable;
            };
            formPersonalizationToolbar.prototype.targetIsClickable = function (target) {
                var control = $dyn.ax.personalizationUtil.getPersonalizableControl(target);
                if (control && control.isControlAvailableForExpando) {
                    // When control is selected for move then click happens to initiate move and hence target should not be clickable
                    return control.isControlAvailableForExpando() && !$dyn.ax.personalizationUtil.isControlSelectedForMove(control);
                }
                return false;
            };
            /**
             * Determine if provided element is a react grid scrollbar
             * @param element Element to evaluate
             * @returns True if element is a react grid scrollbar
             */
            formPersonalizationToolbar.prototype.isReactGridScrollbar = function (element) {
                return element && element.classList && (element.classList.contains("ScrollbarLayout_face") || element.classList.contains("ScrollbarLayout_main"));
            };
            /**
             * Determine if provided element is a react grid reorder handle
             * @param element Element to evaluate
             * @returns True if element is a react grid reorder handle
             */
            formPersonalizationToolbar.prototype.isReactGridReorderHandle = function (element) {
                return element && element.classList && element.classList.contains("fixedDataTableCellLayout_columnReorderContainer");
            };
            formPersonalizationToolbar.prototype.IsPropertyEligibleForPendingPersonalization = function (property) {
                return property === $dyn.ax.personalizableProperties.Visible
                    || property === $dyn.ax.personalizableProperties.FastTabSummary
                    || property === $dyn.ax.personalizableProperties.CanFocus
                    || property === $dyn.ax.personalizableProperties.AllowEdit
                    || property === $dyn.ax.personalizableProperties.Mandatory;
            };
            formPersonalizationToolbar.prototype.controlLayoutHorizontal = function (control) {
                if (!control) {
                    return false;
                }
                var isInGrid = control.isInGrid && control.isInGrid();
                var isNormalTab = false;
                if (control instanceof $dyn.controls.PivotItem || control instanceof $dyn.controls.SectionPage) {
                    isNormalTab = $dyn.value(control.getParent().Style) === $dyn.ui.autoValue;
                }
                return isInGrid || isNormalTab;
            };
            // Qtip functions
            formPersonalizationToolbar.prototype._destroyExpandoQtip = function () {
                if (this.secondaryOptionQtip) {
                    if (this.secondaryOptionQtip.destroy) {
                        this.secondaryOptionQtip.destroy();
                    }
                    this.secondaryOptionQtip = null;
                    if (this.currentTargetControl) {
                        this.currentTargetControl.element.classList.remove($dyn.ui.personalizationClasses.personalizedElement);
                        this.currentTargetControl = null;
                    }
                }
            };
            /**
             * can show expando qtip
             * @param target target for which personalization is targetted
             * @returns true if can show expando qtip else false
             */
            formPersonalizationToolbar.prototype._canShowExpandoQtip = function (target) {
                var control = $dyn.ax.personalizationUtil.getPersonalizableControl(target);
                // If target is accepted container and target control is not in the non personalizable control list then show expando qtip
                if (this.targetIsClickable(target) &&
                    control.Root &&
                    control.Root.FormName &&
                    (!this.currentNonPersonalizableControls.hasOwnProperty(control.Root.FormName) ||
                        this.currentNonPersonalizableControls[control.Root.FormName] &&
                            !this.currentNonPersonalizableControls[control.Root.FormName].hasOwnProperty(control.Name)) &&
                    !this.isDragging &&
                    !$dyn.ax.formPersonalizationPane.formPersonalizationController.qtip) {
                    return true;
                }
                return false;
            };
            /**
             * shows expando qtip
             * @param event event what triggered the action
             * @param target target for which personalization is targetted
             * @returns false if event propagation is stopped
             */
            formPersonalizationToolbar.prototype._showExpandoQtip = function (event, target) {
                var _this = this;
                var isTargetOnIgnoreFocus = $(target).hasClass("ignore-first-focus");
                var control = $dyn.ax.personalizationUtil.getPersonalizableControl(target);
                var mode = this.Mode ? this.Mode() : undefined;
                if (!isTargetOnIgnoreFocus) {
                    if (control && this._canShowExpandoQtip(target)) {
                        this.resetPotentialTarget();
                        if (this.secondaryOptionQtip && this.currentTargetControl !== control) {
                            this._destroyExpandoQtip();
                        }
                        if (!this.secondaryOptionQtip) {
                            var clickHandler_1 = function () {
                                $dyn.ax.personalizationModeEventHandlers[mode].onClick(_this, control);
                                if (_this._canUpdateFormPersonalizaData(mode)) {
                                    _this.updateFormPersonalizationData();
                                }
                                event.stopPropagation();
                                if (mode !== $dyn.ax.personalizationMode.move && mode !== $dyn.ax.personalizationMode.select) {
                                    _this._focusExpandoTargetElement(control);
                                }
                                $dyn.log.stopPropagation && $dyn.log.stopPropagation("Stop propagation in show expando qtip");
                            };
                            var keyDownHandler_1 = function (evt) {
                                var key = evt.which;
                                if ($dyn.ax.personalizationUtil.isActionKey(key)) {
                                    _this._handleKeyDown(target, evt);
                                    event.stopPropagation();
                                    $dyn.log.stopPropagation && $dyn.log.stopPropagation("Stop propagation in key down handler of expando qtip");
                                    if (mode !== $dyn.ax.personalizationMode.move && mode !== $dyn.ax.personalizationMode.select) {
                                        _this._focusExpandoTargetElement(control);
                                    }
                                }
                                else if (key === $dyn.ui.KeyCodes.rightArrow) {
                                    $dyn.util.handleShortcuts(_this, evt);
                                }
                            };
                            var symbolClassName = this._getSymbolClass(mode);
                            var elementToShowQtip_1;
                            if (control instanceof $dyn.controls.PivotItem) {
                                elementToShowQtip_1 = control.getPersonalizableTarget();
                            }
                            if (!elementToShowQtip_1) {
                                elementToShowQtip_1 = control.element;
                            }
                            $(elementToShowQtip_1).qtip({
                                content: '<button class="personalizationToolbar-symbolButton button secondaryQtipButton secondaryQtipSymbol" type="button" data-dyn-image-type="Image" data-dyn-button-display="ImageOnly" data-dyn-button-display="ImageOnly"><div class="button-container secondaryQtipSymbol"><span data-dyn-image-type="Symbol" class="button-commandRing secondaryQtipSymbol ' + symbolClassName + '"></span></div></button>',
                                events: {
                                    show: function () {
                                        $(".qtip-content").click(clickHandler_1);
                                        $(".secondaryQtipButton").keydown(keyDownHandler_1);
                                    }
                                },
                                hide: "unfocus",
                                position: {
                                    at: "top left",
                                    my: "top right",
                                    target: $(elementToShowQtip_1),
                                },
                                show: false,
                                style: {
                                    classes: "secondaryQtipContent secondaryQtipSymbol",
                                },
                            }).qtip("api");
                            this.secondaryOptionQtip = $(elementToShowQtip_1).qtip("api");
                            this.secondaryOptionQtip.show();
                            $dyn.async(function () {
                                if (elementToShowQtip_1 && _this.secondaryOptionQtip && _this.secondaryOptionQtip.tooltip && _this.secondaryOptionQtip.tooltip.width) {
                                    _this.secondaryOptionQtip.tooltip.css({
                                        left: $(elementToShowQtip_1).offset().left - _this.secondaryOptionQtip.tooltip.width() - 2,
                                        top: $(elementToShowQtip_1).offset().top
                                    });
                                }
                            }, undefined, "delay applying qTip styles");
                            this.currentTargetControl = control;
                        }
                    }
                    else if ($(target).hasClass("secondaryQtipSymbol") || $(target).hasClass("secondaryQtipContent") || $(target).hasClass("qtip-content")) {
                        event.stopPropagation();
                        $dyn.log.stopPropagation && $dyn.log.stopPropagation("Stop propagation in show expando qtip");
                        return false;
                    }
                    else {
                        this._destroyExpandoQtip();
                    }
                }
                return true;
            };
            /**
             * finds header element of control
             * @param control control whose header element needs to be found
             */
            formPersonalizationToolbar.prototype._focusExpandoTargetElement = function (control) {
                var $elementToFocus;
                if (control && control.getExpandoPersonalizationFocusTarget) {
                    $elementToFocus = control.getExpandoPersonalizationFocusTarget();
                }
                if ($elementToFocus) {
                    if (control.Root && control.Root.setControlFocus) {
                        control.Root.setControlFocus($elementToFocus[0], true);
                    }
                    // Below is required when actiive control is current clickable control and user is toggling between expando and control
                    // Then above function can not put the focus back to active control because active control did not changed.
                    if (document.activeElement !== $elementToFocus[0]) {
                        $elementToFocus.focus();
                        $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s)->_focusExpandoTargetElement header of container control name: %s", control.Root.Id, control.Name);
                    }
                }
            };
            // Accessibility functions
            formPersonalizationToolbar.prototype.updateAccessibilityDescriptionForTarget = function (target) {
                // Do not alert on controls that are not part of the personalizing form
                // and concede alerting on this region to move mode specific handling when move operation in progress.
                if (this.targetIsPersonalizing(target) && !this.selectedForMove) {
                    var $alert = $("#PersonalizationToolbar_LiveHelp");
                    $alert.empty();
                    var message = void 0;
                    var controlContext = this.getPersonalizableControl(target);
                    if (controlContext) {
                        message = this.getPersonalizedStateMessage(controlContext);
                    }
                    else {
                        message = $dyn.label("FormPersonalization_CannotBePersonalized");
                    }
                    $alert.append(message);
                }
            };
            formPersonalizationToolbar.prototype.updateAccessibilityDescriptionForMove = function (selecting, proposedNewSibling) {
                if (selecting === void 0) { selecting = false; }
                if (proposedNewSibling === void 0) { proposedNewSibling = null; }
                var $alert = $("#PersonalizationToolbar_LiveHelp");
                $alert.empty();
                var message;
                if (selecting) {
                    message = $dyn.label("FormPersonalization_SelectedForMove");
                }
                else if (proposedNewSibling) {
                    var contextControl = $dyn.context(proposedNewSibling);
                    if (!contextControl) {
                        // The move location may not have a context when part of a breakable group is proposed
                        var controlElement = $(proposedNewSibling).addBack().closest("[data-dyn-controlname]")[0];
                        contextControl = $dyn.context(controlElement);
                    }
                    if (contextControl) {
                        // AccessibilityLabel is no longer used therefore Label must be use in its place
                        // Since not all controls have labels, label value will need to be evaluated
                        var labelValue = $dyn.value(contextControl.Label);
                        if (labelValue) {
                            message = $dyn.format($dyn.label("FormPersonalization_MoveNextTo"), labelValue);
                        }
                    }
                }
                else {
                    message = $dyn.label("FormPersonalization_UnselectedForMove");
                }
                $alert.append(message);
            };
            formPersonalizationToolbar.prototype.getPersonalizedStateMessage = function (controlContext) {
                var message;
                if (controlContext.element.classList.contains($dyn.ui.personalizationClasses.personalized)) {
                    message = $dyn.label("FormPersonalization_IsPersonalized");
                }
                else {
                    message = $dyn.label("FormPersonalization_CanBePersonalized");
                }
                return message;
            };
            // Manage Personalizations
            formPersonalizationToolbar.prototype.ApplyPersonalizations = function (formName, property, value, control) {
                var $form = this.getPersonalizedFormByName(formName);
                if ($form) {
                    if (this.IsPropertyEligibleForPendingPersonalization(property)) {
                        if (control) {
                            var controlName = control.Name;
                            var isGroupControl = control instanceof $dyn.controls.Group;
                            this.QueuePendingPersonalizations(formName, property, value, controlName);
                            // As this is a pending personalizations we have to apply visual change in client
                            var removeClass = false;
                            var personalizedClass = void 0;
                            switch (property) {
                                case $dyn.ax.personalizableProperties.Visible:
                                    removeClass = value.toLowerCase() === "true" ? true : false;
                                    personalizedClass = $dyn.ui.personalizationClasses.hidden;
                                    break;
                                case $dyn.ax.personalizableProperties.FastTabSummary:
                                    removeClass = value.toLowerCase() === "false" ? true : false;
                                    personalizedClass = $dyn.ui.personalizationClasses.summary;
                                    break;
                                case $dyn.ax.personalizableProperties.CanFocus:
                                    removeClass = value.toLowerCase() === "true" ? true : false;
                                    personalizedClass = $dyn.ui.personalizationClasses.skipped;
                                    break;
                                case $dyn.ax.personalizableProperties.AllowEdit:
                                    removeClass = value.toLowerCase() === "true" ? true : false;
                                    personalizedClass = $dyn.ui.personalizationClasses.locked;
                                    break;
                                case $dyn.ax.personalizableProperties.Mandatory:
                                    removeClass = value.toLowerCase() === "false" ? true : false;
                                    personalizedClass = $dyn.ui.personalizationClasses.personalizedAsMandatory;
                                    break;
                            }
                            this._addClassToNestedControl(controlName, $form, $dyn.ui.personalizationClasses.personalized, isGroupControl, removeClass);
                            this._addClassToNestedControl(controlName, $form, personalizedClass, isGroupControl, removeClass);
                        }
                    }
                    else {
                        // These part executes when personaliation will be send to server immediately
                        // However, currently Persist Call of server only saves to database and aplies the property and do not do the task recorder part
                        // In future all the ExecutePersonalizationCommand call to apply a property should call this function
                        // go through this route when server needs to modify to do the task recording part done
                        // As part of ExecutePersonaliation command
                        var persistPersonalizationObject = void 0;
                        if (control && control.PersistPersonalization) {
                            persistPersonalizationObject = control;
                        }
                        else {
                            var formObject = $dyn.context($form[0]);
                            if (formObject && formObject.PersistPersonalization) {
                                persistPersonalizationObject = formObject;
                            }
                        }
                        if (persistPersonalizationObject) {
                            $dyn.callFunction(persistPersonalizationObject.PersistPersonalization, persistPersonalizationObject, [property, value]);
                        }
                    }
                }
            };
            formPersonalizationToolbar.prototype.QueuePendingPersonalizations = function (formName, property, value, controlName) {
                if (this.IsPropertyEligibleForPendingPersonalization(property)) {
                    var propertyKey = controlName + ":" + property;
                    if (!this._multiplePersonalizations.hasOwnProperty(formName)) {
                        this._multiplePersonalizations[formName] = {};
                    }
                    this._multiplePersonalizations[formName][propertyKey] = value;
                }
            };
            formPersonalizationToolbar.prototype.SavePendingPersonalization = function () {
                var e_4, _a;
                for (var formName in this._multiplePersonalizations) {
                    if (this._multiplePersonalizations.hasOwnProperty(formName)) {
                        var propertyObject = this._multiplePersonalizations[formName];
                        var formRunConfigurationPropertyClassList = [];
                        for (var propertyKey in propertyObject) {
                            if (propertyObject.hasOwnProperty(propertyKey)) {
                                // property key is in the form control:property
                                var keyArray = propertyKey.split(":");
                                var controlName = keyArray[0];
                                var propertyName = keyArray[1];
                                var propertyValue = propertyObject[propertyKey];
                                // Only save pending personalizations if they do not belong to already saved personalizations or if their saved value is different
                                if (!this.currentPersonalizationsControlPropertyMap.hasOwnProperty(formName) ||
                                    !this.currentPersonalizationsControlPropertyMap[formName].hasOwnProperty(propertyKey) ||
                                    this.currentPersonalizationsControlPropertyMap[formName][propertyKey].toLowerCase() !== propertyValue.toLowerCase()) {
                                    formRunConfigurationPropertyClassList.push({
                                        __type: "FormRunConfigurationPropertyClass:#Dynamics.AX.Application",
                                        ControlValue: controlName,
                                        DocumentExtensionValue: "",
                                        ExtensionValue: "",
                                        PropertyValue: propertyName,
                                        ValueValue: propertyObject[propertyKey],
                                    });
                                }
                            }
                        }
                        if (formRunConfigurationPropertyClassList.length > 0) {
                            var serializedString = JSON.stringify({ "PropertyList": formRunConfigurationPropertyClassList });
                            var formObject = void 0;
                            try {
                                for (var _b = (e_4 = void 0, __values(this.currentVisibleForms)), _c = _b.next(); !_c.done; _c = _b.next()) {
                                    var form = _c.value;
                                    if (form && form.FormName === formName) {
                                        formObject = form;
                                        break;
                                    }
                                }
                            }
                            catch (e_4_1) { e_4 = { error: e_4_1 }; }
                            finally {
                                try {
                                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                }
                                finally { if (e_4) throw e_4.error; }
                            }
                            if (formObject && formObject.SavePendingPersonalization) {
                                formObject.SavePendingPersonalization(serializedString);
                            }
                        }
                    }
                }
                this._multiplePersonalizations = {};
            };
            formPersonalizationToolbar.prototype.updatePersonalizedControls = function () {
                var mode = this.Mode();
                var propertyKey = "";
                var personalizedClass = "";
                switch (mode) {
                    case $dyn.ax.personalizationMode.hide:
                        propertyKey = $dyn.ax.personalizableProperties.Visible + "_false";
                        personalizedClass = $dyn.ui.personalizationClasses.hidden;
                        break;
                    case $dyn.ax.personalizationMode.addToSummary:
                        propertyKey = $dyn.ax.personalizableProperties.FastTabSummary + "_true";
                        personalizedClass = $dyn.ui.personalizationClasses.summary;
                        break;
                    case $dyn.ax.personalizationMode.skip:
                        propertyKey = $dyn.ax.personalizableProperties.CanFocus + "_false";
                        personalizedClass = $dyn.ui.personalizationClasses.skipped;
                        break;
                    case $dyn.ax.personalizationMode.lock:
                        propertyKey = $dyn.ax.personalizableProperties.AllowEdit + "_false";
                        personalizedClass = $dyn.ui.personalizationClasses.locked;
                        break;
                    case $dyn.ax.personalizationMode.mandatory:
                        propertyKey = $dyn.ax.personalizableProperties.Mandatory + "_true";
                        personalizedClass = $dyn.ui.personalizationClasses.personalizedAsMandatory;
                        break;
                }
                // Remove all previous indicators
                this.resetIndicators();
                this._applyPersonalizableClasses(this.currentPersonalizableControls, $dyn.ui.personalizationClasses.canBePersonalized);
                this._applyPersonalizableClasses(this.currentNonPersonalizableControls, $dyn.ui.personalizationClasses.cannotBePersonalized);
                this.toggleNonPersonalizableDocumentSurfaces(false);
                if (!propertyKey) {
                    return;
                }
                propertyKey = propertyKey.toLowerCase();
                // Iterate over the controls with this property applied and update their css classes
                for (var formName in this.currentPersonalizations) {
                    if (this.currentPersonalizations[formName] && this.currentPersonalizations[formName][propertyKey]) {
                        var $form = this.getPersonalizedFormByName(formName);
                        var controlNames = this.currentPersonalizations[formName][propertyKey];
                        for (var j = controlNames.length - 1; j >= 0; j--) {
                            var controlName = controlNames[j];
                            this._addClassToNestedControl(controlName, $form, $dyn.ui.personalizationClasses.personalized, true);
                            this._addClassToNestedControl(controlName, $form, personalizedClass);
                        }
                    }
                }
            };
            formPersonalizationToolbar.prototype.updateFormPersonalizationData = function (forceGetVisibleForms) {
                var e_5, _a;
                var _this = this;
                if (forceGetVisibleForms === void 0) { forceGetVisibleForms = false; }
                this.rootFormElement = $dyn.shell.getCurrentDialog() || $dyn.shell.getCurrentRootForm();
                var rootForm = $dyn.context(this.rootFormElement);
                if (rootForm && $dyn.value(rootForm.AllowExplicitPersonalization)) {
                    var mode = this.Mode ? this.Mode() : undefined;
                    if (mode === $dyn.ax.personalizationMode.hide) {
                        this.showHiddenFields(true);
                    }
                    if (forceGetVisibleForms) {
                        this.getCurrentlyVisibleForms(rootForm);
                    }
                    // The resources will be loaded non-sequentially.
                    var resources_1 = [];
                    var _loop_1 = function (currentForm) {
                        var callUpdate = function (d) {
                            $dyn.callFunction(currentForm.UpdatePersonalizationData, currentForm, [_this.Mode()], function () {
                                d.resolve();
                            });
                        };
                        var deferred_1 = $.Deferred();
                        callUpdate(deferred_1);
                        resources_1.push(deferred_1.promise());
                    };
                    try {
                        for (var _b = __values(this.currentVisibleForms), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var currentForm = _c.value;
                            _loop_1(currentForm);
                        }
                    }
                    catch (e_5_1) { e_5 = { error: e_5_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_5) throw e_5.error; }
                    }
                    $.when.apply($.when, resources_1).done(function () {
                        var e_6, _a;
                        // All of the forms have finished refreshing, now read all of the property bags off of each form
                        _this.currentPersonalizations = {};
                        _this.currentPersonalizableControls = {};
                        _this.currentNonPersonalizableControls = {};
                        _this.currentPersonalizationsControlPropertyMap = {};
                        try {
                            for (var _b = __values(_this.currentVisibleForms), _c = _b.next(); !_c.done; _c = _b.next()) {
                                var currentForm = _c.value;
                                var formName = currentForm.FormName;
                                _this.currentPersonalizations[formName] = {};
                                _this.currentPersonalizableControls[formName] = {};
                                _this.currentNonPersonalizableControls[formName] = {};
                                _this.currentPersonalizationsControlPropertyMap[formName] = {};
                                var data = JSON.parse(currentForm.PersonalizationData());
                                var configurations = data.Configurations;
                                for (var j = configurations.length - 1; j >= 0; j--) {
                                    var config = configurations[j];
                                    var configKey = config.PropertyValue + "_" + config.ValueValue;
                                    var controlPropertyKey = config.ControlValue + ":" + config.PropertyValue;
                                    configKey = configKey.toLowerCase();
                                    if (!_this.currentPersonalizations[formName][configKey]) {
                                        _this.currentPersonalizations[formName][configKey] = [];
                                    }
                                    _this.currentPersonalizations[formName][configKey].push(config.ControlValue);
                                    _this.currentPersonalizationsControlPropertyMap[formName][controlPropertyKey] = config.ValueValue;
                                    _this.QueuePendingPersonalizations(formName, config.PropertyValue, config.ValueValue, config.ControlValue);
                                }
                                var personalizableControls = data.PersonalizableControls;
                                for (var j = personalizableControls.length - 1; j >= 0; j--) {
                                    var controlName = personalizableControls[j];
                                    _this.currentPersonalizableControls[formName][controlName] = true;
                                }
                                var nonPersonalizableControls = data.NonPersonalizableControls;
                                for (var j = nonPersonalizableControls.length - 1; j >= 0; j--) {
                                    var controlName = nonPersonalizableControls[j];
                                    _this.currentNonPersonalizableControls[formName][controlName] = true;
                                }
                            }
                        }
                        catch (e_6_1) { e_6 = { error: e_6_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_6) throw e_6.error; }
                        }
                        _this.setToolbarControlButtonState();
                        $dyn.deferred.onTrue(function () { return !$dyn.value($dyn.ui.layout); }).done(function () {
                            _this.updatePersonalizedControls();
                        });
                    });
                }
            };
            formPersonalizationToolbar.prototype._applyPersonalizableClasses = function (controlList, className) {
                // tslint:disable-next-line:forin
                for (var formName in controlList) {
                    var $form = this.getPersonalizedFormByName(formName);
                    // tslint:disable-next-line:forin
                    for (var controlName in controlList[formName]) {
                        this._addClassToNestedControl(controlName, $form, className);
                    }
                }
            };
            // Control/target interaction
            formPersonalizationToolbar.prototype.HandleHideForChildControls = function (control, onlyAddMandatoryClass, remove) {
                var e_7, _a;
                if (remove === void 0) { remove = false; }
                if (control) {
                    var isParentContainer = $dyn.value(control.isContainer) || control.Children && control.Children().length > 0 ? true : false;
                    if (isParentContainer) {
                        var childrenInsideContainer = [];
                        // For part controls, FactBox Children comes as the part links and not the Forms which holds the controls
                        if (control instanceof $dyn.controls.Part) {
                            childrenInsideContainer = control.getChildForms();
                        }
                        else if (control instanceof $dyn.controls.ReactList) {
                            childrenInsideContainer = control.getColumnsOptions();
                        }
                        else if (control.Children) {
                            childrenInsideContainer = control.Children();
                        }
                        if (childrenInsideContainer && childrenInsideContainer.length > 0) {
                            try {
                                for (var childrenInsideContainer_1 = __values(childrenInsideContainer), childrenInsideContainer_1_1 = childrenInsideContainer_1.next(); !childrenInsideContainer_1_1.done; childrenInsideContainer_1_1 = childrenInsideContainer_1.next()) {
                                    var childControl = childrenInsideContainer_1_1.value;
                                    if (childControl) {
                                        var $childElement = $(childControl.element);
                                        var formNameToCheck = childControl.Root && childControl.Root.FormName ? childControl.Root.FormName : childControl.FormName;
                                        if (!onlyAddMandatoryClass && childControl.Name && formNameToCheck && this._multiplePersonalizations[formNameToCheck]) {
                                            var propertyKey = childControl.Name + ":" + $dyn.ax.personalizableProperties.Visible;
                                            if (this._multiplePersonalizations[formNameToCheck][propertyKey] &&
                                                this._multiplePersonalizations[formNameToCheck][propertyKey].toLowerCase() === "false") {
                                                this.ApplyPersonalizations(formNameToCheck, $dyn.ax.personalizableProperties.Visible, "True", childControl);
                                            }
                                        }
                                        var isChildContainer = $dyn.value(childControl.isContainer) || childControl.Children && childControl.Children().length > 0 ? true : false;
                                        if (isChildContainer) {
                                            this.HandleHideForChildControls(childControl, onlyAddMandatoryClass, remove);
                                        }
                                        else if (onlyAddMandatoryClass && !$dyn.ax.personalizationUtil.checkIfSummaryField(childControl.TypeName) && $dyn.value(childControl.Required)) {
                                            if (remove) {
                                                $childElement.removeClass($dyn.ui.personalizationClasses.mandatory);
                                            }
                                            else {
                                                $childElement.addClass($dyn.ui.personalizationClasses.mandatory);
                                            }
                                        }
                                    }
                                }
                            }
                            catch (e_7_1) { e_7 = { error: e_7_1 }; }
                            finally {
                                try {
                                    if (childrenInsideContainer_1_1 && !childrenInsideContainer_1_1.done && (_a = childrenInsideContainer_1.return)) _a.call(childrenInsideContainer_1);
                                }
                                finally { if (e_7) throw e_7.error; }
                            }
                        }
                    }
                    else if (onlyAddMandatoryClass &&
                        !$dyn.ax.personalizationUtil.checkIfSummaryField(control.TypeName) &&
                        $dyn.value(control.Required)) {
                        if (remove) {
                            $(control.element).removeClass($dyn.ui.personalizationClasses.mandatory);
                        }
                        else {
                            $(control.element).addClass($dyn.ui.personalizationClasses.mandatory);
                        }
                    }
                }
            };
            formPersonalizationToolbar.prototype._addClassToNestedControl = function (controlName, $form, className, applyToGroups, remove) {
                var _this = this;
                if (applyToGroups === void 0) { applyToGroups = false; }
                if (remove === void 0) { remove = false; }
                var mode = this.Mode ? this.Mode() : undefined;
                var selectorControlName = $dyn.ui.selector().attr("data-dyn-controlname", controlName).toString();
                var $controls = $form.find(selectorControlName).add(selectorControlName, $form[0]);
                // If control can not be find in form then try finding in dom, overflow buttons may not come under form object
                if ($controls.length === 0) {
                    $controls = $("[data-dyn-controlName='" + controlName + "']");
                }
                var addClassPersonalizableTarget = function (context) {
                    if (context.getPersonalizableTarget) {
                        var $personalizableTargetElement = $(context.getPersonalizableTarget());
                        if ($personalizableTargetElement) {
                            if (remove) {
                                $personalizableTargetElement.removeClass(className);
                            }
                            else {
                                $personalizableTargetElement.addClass(className);
                            }
                        }
                    }
                };
                if ($controls.length === 1) {
                    var context_2 = $dyn.context($controls[0]);
                    if (mode &&
                        (mode !== $dyn.ax.personalizationMode.hide ||
                            className !== $dyn.ui.personalizationClasses.cannotBePersonalized ||
                            !context_2 ||
                            context_2.TypeName !== "AppBarSection")) {
                        // if only one control, then just apply, no check needed
                        if (remove) {
                            $controls.removeClass(className);
                        }
                        else {
                            $controls.addClass(className);
                        }
                        if (context_2) {
                            addClassPersonalizableTarget(context_2);
                            if (mode === $dyn.ax.personalizationMode.hide && className === $dyn.ui.personalizationClasses.personalized) {
                                this.HandleHideForChildControls(context_2, true, remove);
                            }
                        }
                        applyToGroups && $dyn.ax.personalizationUtil.addClassToBreakableGroups($controls[0], className, mode, remove);
                    }
                }
                else if ($controls.length > 1) {
                    // if there is more than one control found, check that it is nested under the given $form context
                    var formName_1 = $form.attr("data-dyn-form-name");
                    $controls.each(function (index, element) {
                        var controlElement = element;
                        var context = $dyn.ui.getLiveControl(controlElement);
                        // Add class when mode is not hide,
                        // Or when mode is hide and class is not can not be personalized because here container may not be hidden but individual controls can be,
                        // Or when class is can not be personalized and the control is not AppBarSection,
                        // because we do not want disabled look for the entire section as controls inside the container can have the personalization
                        if (mode &&
                            (mode !== $dyn.ax.personalizationMode.hide ||
                                className !== $dyn.ui.personalizationClasses.cannotBePersonalized ||
                                !context ||
                                context.TypeName !== "AppBarSection")) {
                            if (context && context.Root && context.Root.FormName === formName_1) {
                                if (remove) {
                                    controlElement.classList.remove(className);
                                }
                                else {
                                    controlElement.classList.add(className);
                                }
                                addClassPersonalizableTarget(context);
                                if (mode === $dyn.ax.personalizationMode.hide && className === $dyn.ui.personalizationClasses.personalized) {
                                    _this.HandleHideForChildControls(context, true, remove);
                                }
                                applyToGroups && $dyn.ax.personalizationUtil.addClassToBreakableGroups(controlElement, className, mode, remove);
                            }
                        }
                    });
                }
            };
            formPersonalizationToolbar.prototype.addPositionIndicator = function (element, className) {
                if (!element) {
                    return;
                }
                var control = $dyn.ui.getLiveControl(element);
                if (control && control.Root && control.Root.UseReactGrid()) {
                    element = this.getElementOrHeader(control.Name, element, true);
                    // Scroll the React Grid If Needed
                    var context_3 = $dyn.ui.getLiveControl(element);
                    if (context_3) {
                        context_3.listControl && context_3.listControl.scrollColumnIntoViewIfNeeded(context_3.Name);
                    }
                }
                element.scrollIntoViewIfNeeded();
                element.classList.add(className);
                this.updateAccessibilityDescriptionForMove(false, element);
                if (control && this.controlLayoutHorizontal(control)) {
                    element.classList.add($dyn.ui.personalizationClasses.movePositionHorizontal);
                }
            };
            formPersonalizationToolbar.prototype.highlightCurrentApprovedPosition = function () {
                this.clearApprovedPositionIndicator();
                var currentPosition = this.currentApprovedPositions[this.currentPosition];
                var parentName = currentPosition[0];
                var controlName = currentPosition[1];
                var controlIsList = function (control) {
                    return control && (control instanceof $dyn.controls.List || control instanceof $dyn.controls.ReactList);
                };
                var controlIsVerticalTab = function (control) {
                    return control && $dyn.value(control.TypeName) === $dyn.ui.TabStyle.vertical;
                };
                // Optionally provide a control context for better results
                var getAttrForSelector = function (parentContext, controlContext) {
                    if (controlContext === void 0) { controlContext = null; }
                    var attr = "data-dyn-controlname";
                    if (controlIsList(parentContext) || (controlContext && controlContext.isInGrid && controlContext.isInGrid())) {
                        // If the parent control is a Grid, add the indicator to the column header, not the control.
                        attr = "data-dyn-columnname";
                    }
                    else if (controlIsVerticalTab(parentContext)) {
                        // If the parent control is a VerticalTab, add the indicator to the tab header, not the control.
                        attr = "data-dyn-mappedtab";
                    }
                    return attr;
                };
                var findEmptySlot = function (parent) {
                    if (!parent) {
                        return null;
                    }
                    var parentContext = $dyn.context(parent);
                    var attr = getAttrForSelector(parentContext);
                    var child = parent.querySelector($dyn.ui.selector().attr(attr).toString());
                    return child;
                };
                var rootForm = this.getPersonalizedFormByName(this.currentApprovedPositions.formName)[0];
                if (controlName) {
                    var parentContext = $dyn.context(rootForm.querySelector($dyn.ui.selector().attr("data-dyn-controlname", parentName).toString()));
                    var controlContext = $dyn.context(rootForm.querySelector($dyn.ui.selector().attr("data-dyn-controlname", controlName).toString()));
                    var attr = getAttrForSelector(parentContext, controlContext);
                    var element = rootForm.querySelector($dyn.ui.selector().attr(attr, controlName).toString());
                    if (element) {
                        element = this.getElementOrHeader(controlName, element);
                        // Check if the element has breakable groups. If so, add the class to the tail group.
                        var tailGroup = $dyn.layout.getTailBreakableGroup(element);
                        element = tailGroup ? tailGroup : element;
                        this.addPositionIndicator(element, $dyn.ui.personalizationClasses.movePositionAfter);
                    }
                }
                else if (parentName) {
                    var firstChild = null;
                    if (parentName.indexOf("FormDesign", 0) === 0) {
                        parentName = parentName.split(":")[1];
                        firstChild = rootForm.querySelector($dyn.ui.selector().attr("data-dyn-form-name", parentName).desc().css("formContainer").desc().css("rootContent").desc().attr("data-dyn-controlname").toString());
                    }
                    else {
                        var parent_1 = rootForm.querySelector($dyn.ui.selector().attr("data-dyn-controlname", parentName).toString());
                        firstChild = findEmptySlot(parent_1);
                    }
                    this.addPositionIndicator(firstChild, $dyn.ui.personalizationClasses.movePositionBefore);
                }
            };
            formPersonalizationToolbar.prototype.clearApprovedPositionIndicator = function () {
                $($dyn.ui.selector().css($dyn.ui.personalizationClasses.movePositionBefore).toString()).removeClass($dyn.ui.personalizationClasses.movePositionBefore);
                $($dyn.ui.selector().css($dyn.ui.personalizationClasses.movePositionAfter).toString()).removeClass($dyn.ui.personalizationClasses.movePositionAfter);
                $($dyn.ui.selector().css($dyn.ui.personalizationClasses.movePositionHorizontal).toString()).removeClass($dyn.ui.personalizationClasses.movePositionHorizontal);
            };
            formPersonalizationToolbar.prototype.toggleNonPersonalizableDocumentSurfaces = function (enabled) {
                $("iframe").each(function (index, element) {
                    $(element).css("pointer-events", enabled ? "all" : "none");
                });
            };
            formPersonalizationToolbar.prototype.resetIndicators = function () {
                this.toggleNonPersonalizableDocumentSurfaces(true);
                $($dyn.ui.selector().css($dyn.ui.personalizationClasses.canBePersonalized).toString()).removeClass($dyn.ui.personalizationClasses.canBePersonalized);
                $($dyn.ui.selector().css($dyn.ui.personalizationClasses.cannotBePersonalized).toString()).removeClass($dyn.ui.personalizationClasses.cannotBePersonalized);
                var personalizedItems = $($dyn.ui.selector().css($dyn.ui.personalizationClasses.personalized).toString());
                personalizedItems.removeClass($dyn.ui.personalizationClasses.personalized);
                personalizedItems.removeClass($dyn.ui.personalizationClasses.hidden);
                personalizedItems.removeClass($dyn.ui.personalizationClasses.summary);
                personalizedItems.removeClass($dyn.ui.personalizationClasses.skipped);
                personalizedItems.removeClass($dyn.ui.personalizationClasses.locked);
            };
            // Form interaction
            formPersonalizationToolbar.prototype.getCurrentlyVisibleForms = function (rootForm) {
                if (rootForm && $dyn.value(rootForm.AllowExplicitPersonalization)) {
                    this.currentVisibleForms = [];
                    this.rootFormElement.classList.add($dyn.ui.personalizationClasses.isPersonalizing);
                    this.currentVisibleForms.push(rootForm);
                    var partForms = rootForm.GetAllPartForms();
                    this.currentVisibleForms = this.currentVisibleForms.concat(partForms);
                    // Retrieve $dyn.controls.FactBoxForm[]
                    var factBoxForms = rootForm.GetAllFactBoxForms();
                    this.currentVisibleForms = this.currentVisibleForms.concat(factBoxForms);
                }
            };
            /**
             * Gets the personalized form with the given name within the scope of the personalized rootFormElement
             * First checks the personalized rootFormElement if it matches the given name and then any sub forms of that main form.
             * @param formName Name of form within the scope of the personalized rootFormElement
             * @returns Returns a jQuery object which may be empty.
             */
            formPersonalizationToolbar.prototype.getPersonalizedFormByName = function (formName) {
                var $form = $(this.rootFormElement);
                $form = $form.attr("data-dyn-form-name") === formName ? $form : $form.find($dyn.ui.selector().attr("data-dyn-form-name", formName).toString());
                return $form;
            };
            formPersonalizationToolbar.prototype.clearRootForm = function () {
                this.rootFormElement && this.rootFormElement.classList.remove($dyn.ui.personalizationClasses.isPersonalizing);
                this.rootFormElement = undefined;
            };
            return formPersonalizationToolbar;
        }());
        ax.formPersonalizationToolbar = formPersonalizationToolbar;
    })(ax = $dyn.ax || ($dyn.ax = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=FormPersonalizationToolbar.js.map
